// extracted by mini-css-extract-plugin
export var checkbox = "ToggleSwitch-module--checkbox--90085";
export var slider = "ToggleSwitch-module--slider--3031e";
export var title = "ToggleSwitch-module--title--5c451";
export var toggle = "ToggleSwitch-module--toggle--3cc07";